import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Izgled",
  "description": "",
  "published": "2007-01-23T00:00:00.000Z",
  "redirect_from": ["/blog/izgled/swizec/310"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Nekatere strani v sirni prostranosti interneta imajo preprosto odlicen sapo jemajoc izgled. Zacuda, ali ne, so to skoraj vedno strani kakih graficnih umetnikov, ki stran uporabljajo, da bi postali bolj znani oz. da pokazejo svoje delo. Ena takih je `}<a parentName="p" {...{
        "href": "http://www.mariawilliam.net/"
      }}>{`Maria J. William`}</a>{`. Moram reci, da tako lepe strani do sedaj se nisem imel casti uzreti.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      